// extracted by mini-css-extract-plugin
export default {"alsoWritten":"usuallyKanaWord_alsoWritten__cV1Hb"};